import { OutlinedButton } from '@/components/layouts/Buttons/OutlinedButton/OutlinedButton';
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { CSSProperties, useMemo } from 'react';
import { CoreTable } from '../CoreTable/CoreTable';

export interface TableWorkspace {
  id: string;
  name: string;
}

interface Props {
  workspaces: TableWorkspace[];
  openWorkspaceDeletionModal: (workspaceId: string) => void;
}

const columnHelper = createColumnHelper<TableWorkspace>();

export function WorkspacesTable({ openWorkspaceDeletionModal, workspaces }: Props) {
  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: 'Name',
      }),
      columnHelper.display({
        id: 'actions',
        header: 'Action',
        cell: (props) => (
          <div>
            <OutlinedButton
              onClick={() => openWorkspaceDeletionModal(props.row.original.id)}
            >
              Delete Workspace
            </OutlinedButton>
          </div>
        ),
      }),
    ],
    [openWorkspaceDeletionModal],
  );

  const handleHeadersStyles = (headerId: string): CSSProperties => {
    if (headerId === 'name') {
      return { width: '100%' };
    } else if (headerId === 'actions') {
      return { width: '195.03px' };
    }
    return {};
  };

  const table = useReactTable({
    data: workspaces,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <CoreTable getHeaderStyles={handleHeadersStyles} table={table} />;
}
